import { render, staticRenderFns } from "./RecruitmentDecision.vue?vue&type=template&id=70d1fb05&scoped=true&"
import script from "./RecruitmentDecision.vue?vue&type=script&lang=js&"
export * from "./RecruitmentDecision.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentDecision.vue?vue&type=style&index=0&id=70d1fb05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1fb05",
  null
  
)

export default component.exports